import Vue from 'vue';
import VueResource from 'vue-resource';
import App from './App.vue';
import { store } from './App.vue';
import router from './app/router';
import VModal from 'vue-js-modal';
import VueFlashMessage from 'vue-flash-message';
import backend from './utils/backend';

require('../scss/vars.scss');
require('../scss/init.scss');
require('vue-flash-message/dist/vue-flash-message.min.css');

const faviconsContext = require.context(
  '../images/favicons/',
  true,
  /\.(svg|png|ico|xml|json)$/
);
faviconsContext.keys().forEach(faviconsContext);

Vue.use(VueResource);
Vue.use(VModal, {dialog: true})
Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 30000,
    pauseOnInteract: true,
  }
});

Vue.http.options.credentials = true;
Vue.config.productionTip = false;

Vue.http.interceptors.push(function(request, next) {
  next(response => {
    if (backend.ssoIsInvalid(response)) {
      backend.redirectToAnonymousAuth();
    }
  });
});

// Don't judge me please :)
window.router = router;

Vue.filter('uppercase', function(value) {
  if (!value) return '';
  value = value.toString();
  return value.toUpperCase();
});

new Vue({
  el: '#app',
  render: h => h(App),
  router,
});



// WEBPACK FOOTER //
// ./src/main.js